import { createStyles, Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

export const useDeliveryTypeSelectStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingRight: theme.spacing(2),
      [theme.breakpoints.down('md')]: {
        paddingRight: 0,
      },
    },
    selectArea: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        alignItems: 'stretch',
      },
    },
    addressArea: {
      alignItems: 'start',
      marginTop: theme.spacing(3),
    },

    label: {
      flex: '0 0 88px',
      fontWeight: 'bold',
      marginRight: theme.spacing(1),
      [theme.breakpoints.down('md')]: {
        flex: '0 0 auto',
        marginRight: 0,
        marginBottom: theme.spacing(1),
      },
    },
    addressLabel: {
      marginTop: -1,
      [theme.breakpoints.down('md')]: {
        marginTop: 0,
      },
    },
    select: {
      flexGrow: 1,
      '& > .MuiSelect-selectMenu': {
        paddingLeft: '16px',
        paddingRight: '30px',
        '&:focus': {
          backgroundColor: 'transparent',
        },
      },
    },
  })
)
